import React from "react";
import {FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {payoutScheduleOptions} from "../constants/securspace-constants";

interface PayoutScheduleSelectProps {
    selection?: string;
    handleChangeSelection: (event: SelectChangeEvent) => void;
}

const PayoutScheduleSelect = (props: PayoutScheduleSelectProps) => {
    const {selection, handleChangeSelection} = props;

    return(
        <FormControl variant="standard" fullWidth>
            <InputLabel id='ssPayoutScheduleSelect' variant={'standard'} color={'primary'}>Payout Schedule</InputLabel>
            <Select
                value={selection || payoutScheduleOptions[0].value}
                onChange={handleChangeSelection}
                labelId="ssPayoutScheduleSelect"
                name={'payoutSchedule'}
                fullWidth
            >
                {
                payoutScheduleOptions.map(item => (
                    <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))
                }
            </Select>
        </FormControl>
    )
}

export default PayoutScheduleSelect;
